module.exports = __webpack_public_path__ + "img/loading-no-bg.cac6f4f6.gif";